(function () {
  'use strict';
  var periods = [
    { month: 10, start: 20, end: 26, label: '10.20-10.26' },
    { month: 10, start: 27, end: 31, label: '10.27-11.2' },
    { month: 11, start: 1, end: 2, label: '10.27-11.2' },
    { month: 11, start: 3, end: 9, label: '11.3-11.9' },
    { month: 11, start: 10, end: 16, label: '11.10-11.16' },
    { month: 11, start: 17, end: 19, label: '11.17-11.19' },
    { month: 11, start: 20, end: 22, label: '11.20-11.22' }
  ];
  function cardForDate(year, month, day) {
    if (year !== 2026) return null;
    if (month === 11 && day >= 23 && day <= 30) {
      return { type: 'b', label: '11.' + day, reveal: 'Prize revealed on Nov 20th.' };
    }
    var period = periods.find(function (item) { return item.month === month && day >= item.start && day <= item.end; });
    return period ? { type: 'a', label: period.label, reveal: 'Prize revealed on Monday.' } : null;
  }
  function show(root, year, month, day) {
    var card = cardForDate(year, month, day);
    if (!card) return;
    var dialog = root.querySelector('dialog');
    root.querySelector('[data-bf-howto]').hidden = true;
    root.querySelector('[data-bf-prize]').hidden = false;
    dialog.classList.add('is-prize', 'is-pre-prize');
    dialog.dataset.bfPreCardType = card.type;
    var revealed = root.hasAttribute('data-bf-revealed-week') && year === 2026 && month === 10 && day >= 20 && day <= 26;
    var secondWeek = year === 2026 && ((month === 10 && day >= 27 && day <= 31) || (month === 11 && day >= 1 && day <= 2));
    var secondWeekRevealed = secondWeek && root.hasAttribute('data-bf-revealed-second-week');
    var secondWeekArt = root.querySelector('[data-bf-second-week-art]');
    var secondWeekMysteryArt = root.querySelector('[data-bf-second-week-mystery-art]');
    var secondWeekCopy = root.querySelector('[data-bf-second-week-copy]');
    var formalSecondWeek = secondWeek && !!secondWeekArt;
    var thirdWeek = year === 2026 && month === 11 && day >= 3 && day <= 9;
    var thirdWeekArt = root.querySelector('[data-bf-third-week-art]');
    var thirdWeekMysteryArt = root.querySelector('[data-bf-third-week-mystery-art]');
    var thirdWeekCopy = root.querySelector('[data-bf-third-week-copy]');
    var formalThirdWeek = thirdWeek && !!thirdWeekArt;
    var thirdWeekRevealed = formalThirdWeek && root.hasAttribute('data-bf-revealed-third-week');
    dialog.classList.toggle('is-third-week-prize', formalThirdWeek);
    dialog.classList.toggle('is-second-week-prize', formalSecondWeek);
    dialog.classList.toggle('is-revealed-prize', revealed || secondWeekRevealed || thirdWeekRevealed);
    root.querySelector('[data-bf-card-title]').textContent = thirdWeekRevealed ? 'GoPro HERO13' : secondWeekRevealed ? 'Pongbot Tennis Racquet' : revealed ? 'Apple Watch SE 3' : 'Coming Soon';
    root.querySelector('[data-bf-mystery-art]').hidden = revealed || formalSecondWeek || formalThirdWeek;
    root.querySelector('[data-bf-mystery-copy]').hidden = revealed || secondWeekRevealed || thirdWeekRevealed;
    var revealedArt = root.querySelector('[data-bf-revealed-art]');
    var revealedCopy = root.querySelector('[data-bf-revealed-copy]');
    if (revealedArt) revealedArt.hidden = !revealed;
    if (revealedCopy) revealedCopy.hidden = !revealed;
    if (secondWeekArt) secondWeekArt.hidden = !secondWeekRevealed;
    if (secondWeekMysteryArt) secondWeekMysteryArt.hidden = !formalSecondWeek || secondWeekRevealed;
    if (secondWeekCopy) secondWeekCopy.hidden = !secondWeekRevealed;
    if (thirdWeekArt) thirdWeekArt.hidden = !thirdWeekRevealed;
    if (thirdWeekMysteryArt) thirdWeekMysteryArt.hidden = !formalThirdWeek || thirdWeekRevealed;
    if (thirdWeekCopy) thirdWeekCopy.hidden = !thirdWeekRevealed;
    root.querySelector('[data-bf-pre-card-date]').textContent = formalThirdWeek ? '11.3-11.9' : secondWeekRevealed || formalSecondWeek ? '10/27-11/2' : revealed ? '10/20-10/26' : card.label;
    root.querySelector('[data-bf-pre-card-reveal]').textContent = card.reveal;
    var desktop = root.hasAttribute('data-bf-pc-calendar');
    if (dialog.open && dialog.matches(':modal') === desktop) dialog.close();
    if (!dialog.open) {
      if (!desktop && typeof dialog.showModal === 'function') dialog.showModal();
      else if (typeof dialog.show === 'function') dialog.show();
      else dialog.setAttribute('open', '');
    }
    var layer = root.querySelector('[data-bf-confetti]');
    layer.hidden = false;
    if (window.BFCalendarConfetti) window.BFCalendarConfetti.start(layer);
  }
  window.BFPreCalendar = { cardForDate: cardForDate, show: show };
})();
